import React, { Fragment } from "react";
import MaterialInput from "../UI/MaterialInput";
import { ButtonSolid } from "../../../components/styledConstants";
import IconRefresh from "../../../assets/images/IconRefresh";

const FilterBox = ({
  filterForm = [],
  onFilterChange = () => {},
  onFilterSubmit = () => {},
  className = "",
  buttonValue = "SEARCH", // Set the default value to "SEARCH"
  refreshPage,
}) => {
  return (
    <form className={`${className} flex flex-start gap10`} onSubmit={onFilterSubmit}>
      {filterForm.map((item, i) => (
        <Fragment key={`filter-${i}`}>
          <MaterialInput {...item} onChange={(e) => onFilterChange(e, i)} />
        </Fragment>
      ))}
      {/* Conditionally render the search button if buttonValue is not an empty string */}
      {buttonValue && (
        <ButtonSolid primary xl type="submit">
          {buttonValue}
        </ButtonSolid>
      )}
      {/* Conditionally render the refresh button */}
      {refreshPage && (
        <ButtonSolid primary xl className="refresh-button" type="button" onClick={refreshPage}>
          <IconRefresh />
        </ButtonSolid>
      )}
    </form>
  );
};

export default React.memo(FilterBox);
